import { CitacaoModalComponent } from './../../shared/citacao-modal/citacao-modal.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ClipboardService } from 'ngx-clipboard';
import { Observable } from 'rxjs';
import { Breadcrumb } from 'src/app/shared/breadcrumb/breadcrumb.model';


@Component({
  selector: 'app-curso',
  templateUrl: './curso.component.html',
  styleUrls: ['./curso.component.scss'],
  providers: [DatePipe],
})
export class CursoComponent implements OnInit {
  linkDescricao: string;
  linkSite: string;
  date: any;
  quoteCopyIcon = 'assets/common/copy2.svg';
  preaLoadedImage = (new Image().src = 'assets/common/copy2.svg');
  toggleShare = false;
  toggleQuote = false;
  curso: any;
  eixo: any;
  areaTecnologica: any;
  perfilProfissional: string;
  codCine: string;
  preRequisitoIngresso: string;
  legislacoes: any[];
  ocupacoesCbo: string;
  itinerariosFormativos: any;
  campoAtuacao: any;
  infraestruturaMinima: any;
  nomeclaturasAnteriores: any;
  displayAll = true;
  citacao: string;
  isCollapsed: boolean[] = [
    true, true, true, true, true, true, true, true, true, true
  ];
  isCopied = false;
  // URL da página atual
  pageUrl = encodeURIComponent(window.location.href);
  // Texto opcional para compartilhamento
  shareText = encodeURIComponent('Confira este link incrível!');

  @ViewChild(CitacaoModalComponent) citacaoModal!: CitacaoModalComponent;

  isMobile$: Observable<boolean>;
  breadcrumbItems: Array<Breadcrumb> = [];

  constructor(
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private clipboardService: ClipboardService,
  ) {
    this.date = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
  }

  ngOnInit(): void {
    const {
      curso,
      curso: {
        eixo,
        areaTecnologica,
        ocupacoesCbo,
        perfilProfissional,
        legislacoes,
        infraestruturaMinima,
        itinerariosFormativos,
        campoAtuacao,
        nomeclaturasAnteriores,
      },
    } = this.route.snapshot.data;

    this.curso = curso;
    this.eixo = eixo;
    this.areaTecnologica = areaTecnologica;
    this.perfilProfissional = perfilProfissional;
    this.codCine = curso.codCine ? curso.codCine : '-';
    this.legislacoes = legislacoes && legislacoes.length > 0 ? legislacoes : null;
    this.itinerariosFormativos = itinerariosFormativos;
    this.ocupacoesCbo = ocupacoesCbo && ocupacoesCbo.length > 0 ? ocupacoesCbo : null;
    this.campoAtuacao = campoAtuacao;
    this.infraestruturaMinima = infraestruturaMinima;
    this.nomeclaturasAnteriores = nomeclaturasAnteriores && nomeclaturasAnteriores.length > 0
      ? nomeclaturasAnteriores
      : null;
    this.linkDescricao = `Veja as informações sobre o curso ${this.curso.nome} no Catálogo Nacional de Cursos Superiores de Tecnologia:`;
    this.linkSite = window.location.href; // window.location.origin;
    this.citacao = `BRASIL. Ministério da Educação. Catálogo Nacional de Cursos Superiores de Tecnologia, 4ª ed. Brasília: MEC, 2024. Disponível em:`;

    this.breadcrumbItems = [
      { label: 'Página Inicial', url: '/' },
      { label: 'Todos os Cursos', url: '/cursos' },
      { label: eixo.nome, url: `/cursos/eixo-tecnologico?id=${eixo.id}` },
      ...(areaTecnologica?.nome ? [{
        label: areaTecnologica.nome,
        url: `/cursos/area?areaId=${areaTecnologica.id}&eixoId=${eixo.id}`
      }] : []),
      { label: curso.nome }
    ];

  }

  copyQuote(quoteText: any) {
    this.clipboardService.copy(quoteText.innerText);
    this.quoteCopyIcon = 'assets/common/checked.svg';

    setTimeout(() => {
      this.quoteCopyIcon = 'assets/common/copy2.svg';
    }, 2000);
  }

  onToggleQuote(event: any) {
    this.toggleQuote = !this.toggleQuote;
    this.toggleShare = false;
    event.stopPropagation();
  }

  onToggleShare(event: any) {
    this.toggleShare = !this.toggleShare;
    this.toggleQuote = false;
    event.stopPropagation();
  }

  onClickOutside(event: any) {
    this.toggleQuote = false;
    this.toggleShare = false;
  }

  // Método para alternar o colapso explicitamente de uma seção específica.
  toggleCollapse(index: number) {
    this.isCollapsed[index] = !this.isCollapsed[index];
  }

  expandir() {
    for (let a = 0; a < this.isCollapsed.length; a++) {
      this.isCollapsed[a] = !this.isCollapsed[a];
    }
    this.displayAll = !this.displayAll;
  }

  copyLink() {
    this.clipboardService.copy(this.linkSite);
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }

  // URL para compartilhar no Facebook
  get facebookShareUrl(): string {
    return `https://www.facebook.com/sharer/sharer.php?u=${this.pageUrl}`;
  }

  // URL para compartilhar no LinkedIn
  get linkedinShareUrl(): string {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${this.pageUrl}`;
  }

  // URL para compartilhar no Twitter
  get twitterShareUrl(): string {
    return `https://twitter.com/intent/tweet?url=${this.pageUrl}&text=${this.shareText}`;
  }

  // URL para compartilhar no WhatsApp
  get whatsappShareUrl(): string {
    return `https://wa.me/?text=${this.shareText}%20${this.pageUrl}`;
  }

  abrirModal() {
    this.citacaoModal.open();
  }

}
